/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Limits: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M12 7.5C12.3199 7.5 12.6204 7.65337 12.8086 7.91211L20.8086 18.9121C21.0297 19.2163 21.0623 19.619 20.8916 19.9541C20.7209 20.2892 20.3761 20.5 20 20.5H4C3.6239 20.5 3.27908 20.2892 3.1084 19.9541C2.93775 19.619 2.97026 19.2163 3.19141 18.9121L11.1914 7.91211L11.2666 7.82031C11.4546 7.61742 11.7199 7.5 12 7.5ZM5.96387 18.5H18.0361L12 10.1992L5.96387 18.5ZM21 5.5H3V3.5H21V5.5Z'
      fill='currentColor'
    />
  </React.Fragment>
)
